





















import Modal from "../core/Modals/Modal.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import Absence = Employe.Absence;
import AbsenceModalEdit from "./AbsenceModalPartials/AbsenceModalEdit.vue";

export default {
    name: "AbsenceModal",
    components: { AbsenceModalEdit, EditionModal, Modal },
    props: {
        employeId: Number,
        absenceId: Number,
        journalEntryId: Number,
        isNew: Boolean,
        forceConge: Boolean,
    },
    data() {
        return {
            showModal: false,
            absence: null,
            fetching: true,
            editing: false,
            EmployeApi: new EmployeApi(),
            editable: true,
            saving: false,
        };
    },
    created() {
        var self = this;
    },
    watch: {
        absenceId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal) && _.isNumber(this.employeId);
            if (self.showModal) {
                self.fetching = true;
                self.EmployeApi.getAbsence(self.employeId, self.absenceId).then(
                    function (res) {
                        self.absence = res;
                        self.fetching = false;
                        self.editing = true;
                    }
                );
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.absence = new Absence({});
                    if (this.forceConge) {
                        this.absence.is_conge = true;
                    }
                    this.creationModal();
                }
            },
        },
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
            this.$emit("close-modal");
        },
        saveAbsence: function (): Promise<Absence> {
            let self = this;
            if (!self.formIsComplete()) {
                swal(
                    "Erreur lors de la sauvegarde.",
                    "Données incomplètes.",
                    "error"
                );
                return;
            }
            if (self.saving) {
                return;
            } else {
                self.saving = true;
            }

            if (self.journalEntryId) {
                self.absence.journal_entry_id = self.journalEntryId;
            }

            return self.EmployeApi.saveAbsence(
                self.absence.employe_id,
                self.absence
            ).then(function (res) {
                self.$emit("data-saved", self.absence);
                self.saving = false;
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        formIsComplete(): boolean {
            return this.absence.employe_id && this.absence.date_debut;
        },
    },
};
